import React, { useMemo, useState } from 'react'
import styles from './styles.module.scss'
import Link from 'next/link'
import { listRoute } from 'src/consts'
import Image from 'next/image'
import clsx from 'clsx'

export const ReadAlso = ({ data }) => {
  const [dotActive, setDotActive] = useState(0)

  const refsById = useMemo(() => {
    const refs = {}
    data.forEach(item => {
      // @ts-ignore
      refs[item.slug] = React.createRef(null)
    })
    return refs
  }, [data])

  const handleRef = (ref, index) => {
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      })
      setDotActive(index)
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.titleContainer}>Read Also</h2>
        <div>
          {data.map((item, index) => {
            return (
              <span
                key={index}
                className={clsx(styles.dot, {
                  [styles.dotActive]: dotActive === index,
                })}
                onClick={() => handleRef(refsById[item.slug], index)}
              />
            )
          })}
        </div>
      </div>
      <div className={styles.carousel}>
        {data.map((item: any, index: number) => (
          <Link
            key={index}
            href={listRoute({ slug: item.slug })}
            legacyBehavior
          >
            <a className={styles.item} ref={refsById[item.slug]}>
              <div className={styles.title}>
                {item.title}
                <Image
                  src='/assets/icons/icon-green-arrow.svg'
                  width='30'
                  height='30'
                  alt='arrow icon'
                  className={styles.arrow}
                />
              </div>
              <div className={styles.description}>{item.shortPreview}</div>
            </a>
          </Link>
        ))}
      </div>
    </div>
  )
}
